// extracted by mini-css-extract-plugin
export default {"filterList":"FilterList_filterList__AWPpZ"};